export const CARS_L1_CATEGORY_ID = 91;

export default {
  CARS_L1_CATEGORY_ID: CARS_L1_CATEGORY_ID,
};
